import {
  ErrorClass,
  type PlatformComponentDay,
} from '../entities/platform-component';

export const errorClassTextColor: Record<ErrorClass, string> = {
  [ErrorClass.ERROR_CLASS_2]: 'text-yellow-500',
  [ErrorClass.ERROR_CLASS_1]: 'text-red-500',
};

export const errorClassBackgroundColor: Record<ErrorClass, string> = {
  [ErrorClass.ERROR_CLASS_2]: 'bg-yellow-500',
  [ErrorClass.ERROR_CLASS_1]: 'bg-red-500',
};

export const labelFromErrorClass: Record<ErrorClass, string> = {
  [ErrorClass.ERROR_CLASS_2]: 'Error Class 2',
  [ErrorClass.ERROR_CLASS_1]: 'Error Class 1',
};

export function errorClassShown(
  day: PlatformComponentDay,
): ErrorClass | undefined {
  const moreThanOneHourErrorClass1 = day.downtimes.some(
    (downtime) =>
      downtime.errorClass === ErrorClass.ERROR_CLASS_1 &&
      downtime.durationSec >= 3600,
  );
  const someDowntime = day.downtimes.some(
    (downtime) => downtime.durationSec > 0,
  );

  if (moreThanOneHourErrorClass1) {
    return ErrorClass.ERROR_CLASS_1;
  } else if (someDowntime) {
    return ErrorClass.ERROR_CLASS_2;
  } else {
    return undefined;
  }
}
